import o from"styled-components";const e=o.div`
	position: relative;
	border-radius: ${({borderRadius:o})=>`${o}px`};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	overflow: hidden;
	background-color: ${({backgroundColor:o})=>o};
	border: 0.71px solid ${({theme:o})=>o.border.black10};
	padding: 14px;
	min-height: 240px;
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	box-sizing: border-box;
	gap: 30px;
	height: 100%;
`,i=o.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`,t=o.h1`
	margin: 0;
	color: ${({color:o})=>o};
	font-size: 20px;
	font-weight: 500;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.p`
	margin: 0;
	color: ${({color:o})=>o};
	opacity: 0.6;
	font-size: 14px;
	line-height: 18px;
	white-space: pre-wrap;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,p=o.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:o})=>o};
	background: ${({background:o})=>o};
	border-radius: 9999px;
	width: fit-content;
	display: inline-block;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,l=o.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({color:o})=>o};
`,n=o.div`
	position: relative;
	font-size: 92px;
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		display: block;
		width: 55px;
		height: 9px;
		background-color: rgba(0, 0, 0, 0.15);
		border-radius: 9999px;
		filter: blur(5px);
		top: 100px;
		left: 20%;
	}
`,d=o.div`
	opacity: 0.5;
	height: 20px;
`,a=o.div`
	height: 22px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 16px;
`,c=o.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;export{d as CardArrowContainer,e as CardContainer,i as CardContent,n as CardEmoji,l as CardEmojiContainer,a as CardFooter,c as CardFooterContainer,t as CardHeading,p as CardLabel,r as CardParagraph};
